// extracted by mini-css-extract-plugin
export default {"screenContainer":"styles_screenContainer__-z+fN","simpleLabel":"styles_simpleLabel__FxEev"};